<script setup>
import { computed, ref } from 'vue';
import { dateHelper } from '@shop/frontend/web/js/helpers/dateHelper';
import ITeams from '../ITeams/ITeams.vue';

const props = defineProps({
  packageEvent: {
    type: Object,
    required: true,
  },
  isHistory: {
    type: Boolean,
    default: false
  },
});

const eventFormattedDate = ref(
  dateHelper.getFormattedDate(props.packageEvent.startTimestamp, 'D MMMM, dddd HH:mm'),
);

const eventNameForMobile = computed(() => `${props.packageEvent.participants.team.homeTeam.name} X ${props.packageEvent.participants.team.guestTeam.name}`);

</script>

<template>
  <div class="i-package-event" :class="{
    'i-package-event_history': isHistory
  }">
    <div class="i-package-event__details">
      <span class="i-package-event__detail i-package-event__detail_date">
        <span>{{ eventFormattedDate }}</span>
      </span>
      <span class="i-package-event__detail i-package-event__detail_location">
        <svg width="20" height="20">
          <use xlink:href="#location" />
        </svg>
        {{ packageEvent.unitName }}
      </span>
    </div>
    <ITeams 
      v-if="packageEvent.participants?.team" 
      class="i-package-event__teams"
      :first-team="packageEvent.participants.team?.homeTeam" 
      :second-team="packageEvent.participants.team?.guestTeam"
      :show-city="true" 
      :name="packageEvent?.name" 
      :to="packageEvent?.pageLink"
      :is-home-logo-with-opponent="packageEvent?.isHomeLogoWithOpponent"
      :is-home-logo-without-opponent="packageEvent?.settings?.isHomeLogoWithoutOpponent"
      :is-show-tournament="packageEvent?.settings?.isShowTournament" 
      :is-small="isHistory"
      class-name="i-teams_order-package" 
    />
    <div class="i-package-event__name">
      <template v-if="props.packageEvent.isHomeLogoWithOpponent">
        {{ props.packageEvent?.participants?.team?.homeTeam?.name }}
        <span class="i-package-event__versus">-</span>
        {{ props.packageEvent?.participants?.team?.guestTeam?.name }}
      </template>
      <template v-else>
        {{ props.packageEvent?.name }}
      </template>
    </div>
  </div>
</template>

<style lang="scss">
.i-package-event {
  display: flex;
  align-items: center;
  gap: 24px;
  padding: 8px 12px;
  background-color: $light-gray;

  &__details {
    display: flex;
    flex-direction: column;
    gap: 8px;
    max-width: 25%;
  }

  &__detail {
    display: flex;
    gap: 8px;
    font-size: 14px;

    svg {
      min-width: 20px;
    }
  }

  &__detail {
    &_date {
      font-weight: 600;
    }

    &_location {
      color: $grey-second;
    }
  }

  &__name {
    display: none;
  }

  &_history {
    background-color: $white;
  }

  .i-teams {
    min-width: 48%;
    width: 60%;
    margin-bottom: 0;
    flex-grow: 0;
  }

  @media (max-width: $screen-md) {
    align-items: baseline;
    flex-direction: column;
    gap: 8px;
    padding: 8px;
    border-radius: $border-radius;

    &__teams {
      display: none;
    }

    &__name {
      display: block;
      font-size: 14px;
      font-weight: 700;
    }

    &__versus {
      font-size: 14px;
      margin: auto 8px;
    }

    &__details {
      gap: 8px;
      max-width: none;
      order: 2;
    }
  }
}
</style>
